import { Box, Text } from "grommet";
import React, { useEffect, useState } from "react";
import PassengerService from "../../../../../services/passenger/passenger.service";
import StandardColors from "../../../../../util/StandardColors";
import StandardFonts from "../../../../../util/StandardFonts";
import ChatView from "./ChatView";
import { useStore } from "../../../../../Hooks/useStore";
import { observer } from 'mobx-react';
import chatIcon from '../../../../../assets/chatIcon.svg';
import videoCam from '../../../../../assets/videocam.svg';
import videoCam_hover_state from '../../../../../assets/video_call_white.svg';
import expand from '../../../../../assets/expand_content.svg';
import expand_hover_state from '../../../../../assets/expand_content white.svg';
import minimize from '../../../../../assets/collapse_content.svg';
import minimize_hover_state from '../../../../../assets/collapse_content_white.svg';
import audioCall from '../../../../../assets/phone.png';
import audioCallHover from '../../../../../assets/phone_hover.png';
import './ChatCard.css';

export const ChatType = {
  CREW: "crew",
  CAPTAIN: "captain",
};

const ChatCard = observer(({ roomId, style, type, status, onVideocallBtnClicked, onAudiocallBtnClicked, isAudioCallHover, audioHover, isExpandHover, isVideoCallHover, videoHover, expandHover }) => {
  const { rootStore } = useStore();
  const scale = window.innerWidth / window.innerHeight;

  const [passenger, setPassenger] = useState({});

  useEffect(() => {
    (async () => {
      if (rootStore.emsStore.getSelectedEmergency) {
        const passenger_ = await PassengerService.getPassenger(
          rootStore.emsStore.getSelectedEmergency.passengerId
        );
        setPassenger(passenger_);
      }
    })().catch((e) => {
      console.log("ChatCard :error occured while getting passenger", e);
    });
  }, [rootStore.emsStore.getSelectedEmergency]);

  // expand
  const expandChat = (chatType) => {
    if(!rootStore.emsStore.getExpand) {
      rootStore.emsStore.setZIndex();
      setTimeout(() => {
        rootStore.emsStore.setExpand();
      },100);
    }
    if(rootStore.emsStore.getExpand) {
      rootStore.emsStore.setZIndex();
      rootStore.emsStore.setExpand();
    }
    if (rootStore.emsStore.getExpand == false) {
      rootStore.emsStore.setChatType("");
    } else {
      rootStore.emsStore.setChatType(chatType);
    }
  }

  const styles = {
    contentCard: {
      backgroundColor: StandardColors.white,
      borderRadius: 8,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "space-between",
      opacity: status == "RESOLVED" ? 0.4 : 1,
      PointerEvent: status == "RESOLVED" ? 'none' : 'all',
      userSelect: status == "RESOLVED" ? 'none' : 'initial'
    },
    headerContainer: {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    headerTitleContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      flexGrow: 1,
      padding: '8px 14px 14px 14px',
      borderBottom: '1px solid #F6F8FF'
    },
    headerTitleText: {
      fontSize: 16,
      lineHeight: "16px",
      ...StandardFonts._h42028Semibold,
    },
    headerTitleSubTitle: {
      fontSize: 14,
      lineHeight: "16px",
      color: StandardColors._h42028Semibold,
      display: "block",
    },
    headerTitleSubTitleValue: {
      color: StandardColors.black_60,
    },
    chatBoxContainer: { width: "100%", paddingLeft: 14, paddingRight: 14, paddingBottom: 10 },
    videoButtons: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      position: 'relative'
    },
    videoCallBtn: {
      pointerEvents: rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED" ? 'none' : 'all',
      opacity: rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED" ? .6 : 1
    },
    expandAreaBtn: {
      pointerEvents: rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED" ? 'none' : 'all',
      opacity: rootStore.emsStore.getSelectedEmergency?.status == "RESOLVED" ? .6 : 1
    }
  };
  

  return (
    <Box style={{ ...styles.contentCard, ...style }} className="chatcard-main">
      <Box style={styles.headerContainer}>
        <Box style={styles.headerTitleContainer}>
          <Text style={styles.headerTitleText}>
            <Text style={styles.headerTitleSubTitle}>
              <img src={chatIcon} alt="chat icon" style={{width: 18, height: 18,marginRight: 6}} />
              {type === ChatType.CREW ? "Chat with Crew" : "Chat with Pilot"}
            </Text>
          </Text>
          <Box style={styles.videoButtons}>
              <Box onMouseOver={videoHover} onMouseOut={videoHover} onClick={() => onAudiocallBtnClicked(rootStore.emsStore.getSelectedEmergency?.id, rootStore.emsStore.getSelectedEmergency?.flightId, "on","VideoCall")} className="controlBtn" style={styles.videoCallBtn}>
                <img src={isVideoCallHover ? videoCam_hover_state : videoCam} alt="video call icon" />
                {
                  isVideoCallHover
                      &&
                  <div className="tooltip">
                    <Text className="tooltipTxt">Video Call</Text>
                  </div>
                }
              </Box>
              <Box onMouseOver={audioHover} onMouseOut={audioHover} onClick={() => onAudiocallBtnClicked(rootStore.emsStore.getSelectedEmergency?.id, rootStore.emsStore.getSelectedEmergency?.flightId, "off","VoiceCall")} className="controlBtn ml10" style={styles.videoCallBtn}>
                <img src={isAudioCallHover ? audioCallHover : audioCall} alt="video call icon" />
                {
                  isAudioCallHover
                      &&
                  <div className="tooltip">
                    <Text className="tooltipTxt">Audio Call</Text>
                  </div>
                }
              </Box>
            <Box onMouseOver={expandHover} onMouseOut={expandHover} onClick={() => expandChat(type)} className="controlBtn ml10" style={styles.expandAreaBtn}>
              {
                rootStore.emsStore.getExpand
                      ?
                <img src={isExpandHover ? minimize_hover_state : minimize} alt="minimize" />
                :
                <img src={isExpandHover ? expand_hover_state : expand} alt="maximize" />
                
              }
              {
                isExpandHover
                     &&
              <div className="tooltip">
                    <Text className="tooltipTxt">{rootStore.emsStore.getExpand ? "Collapse" :"Expand"}</Text>
              </div>
              }
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        style={styles.chatBoxContainer}
        fill
        className="chat-items-container"
      >
        <ChatView chatType={type} roomId={roomId} medicalStatus={status} />
      </Box>
    </Box>
  );
});

export default ChatCard;